import PropTypes from 'prop-types'
import ToolsUtilities from './bones/ToolsUtilities'
import Preview from './bones/Preview'
import useDashboardPreviewer from './useDashboardPreviewer'
import { Card } from '@/shared/theme/styled-components'

const DashboardPreviewer = ({ updateTable }) => {
  const { t, currentSubscription } = useDashboardPreviewer()

  if (!currentSubscription) {
    return (
      <Card>
        <p>{t('subscriptionTable:no_subscription_selected')}</p>
      </Card>
    )
  }

  return (
    <Card>
      <ToolsUtilities subscription={currentSubscription} updateTable={updateTable} />
      <Preview data={currentSubscription.subscriberData} subscriberId={currentSubscription.id} />
    </Card>
  )
}

DashboardPreviewer.propTypes = {
  updateTable: PropTypes.func,
}

export default DashboardPreviewer
